import { IHealthcareFacility } from '../healthcareFacility/HealthcareFacility.ts';

export interface IHealthcareProfessional {
    id: number;
    name: string;
    healthcareProfessionalType: string;
    licenseNumber: string;
    createdDate: string;
    email: string;
    phoneNumber?: string;
    allowSMS?: boolean;
    smsOptOutSource?: number | null;
    smsPhoneNumber?: string | null;
    firstName: string;
    lastName: string;
    preferredLanguage: string;
    titleID?: number;
    healthcareProfessionalTypeID: number;
    healthcareFacilities: IHealthcareFacility[];
    healthcareProfessionalFacilities: IFacilitySelection[];
    healthcareProfessionalTypes: idName[];
    titles: idName[];
    healthcareFacilityTypes: Array<{ id: number; name: string }>;
}

export class HealthcareProfessional {
    public id: number;
    public name: string;
    public healthcareProfessionalType: string;
    public licenseNumber: string;
    public createdDate: string;
    public email: string;
    public phoneNumber?: string;
    public allowSMS?: boolean;
    public smsOptOutSource?: number | null;
    public smsPhoneNumber?: string | null;
    public firstName: string;
    public lastName: string;
    public preferredLanguage: string;
    public titleID?: number;
    public healthcareProfessionalTypeID: number;
    public healthcareFacilities: IHealthcareFacility[];
    public healthcareProfessionalFacilities: IFacilitySelection[];
    public healthcareProfessionalTypes: idName[];
    public titles: idName[];
    healthcareFacilityTypes: Array<{ id: number; name: string }>;

    constructor(input: IHealthcareProfessional) {
        this.id = input.id;
        this.name = input.name;
        this.healthcareProfessionalType = input.healthcareProfessionalType;
        this.licenseNumber = input.licenseNumber;
        this.createdDate = input.createdDate;
        this.email = input.email;
        this.phoneNumber = input.phoneNumber;
        this.allowSMS = input.allowSMS;
        this.smsOptOutSource = input.smsOptOutSource;
        this.smsPhoneNumber = input.smsPhoneNumber;
        this.firstName = input.firstName;
        this.lastName = input.lastName;
        this.preferredLanguage = input.preferredLanguage;
        this.titleID = input.titleID;
        this.healthcareFacilities = input.healthcareFacilities;
        this.healthcareProfessionalTypeID = input.healthcareProfessionalTypeID;
        this.healthcareProfessionalFacilities = input.healthcareProfessionalFacilities;
        this.healthcareProfessionalTypes = input.healthcareProfessionalTypes;
        this.titles = input.titles;
        this.healthcareFacilityTypes = input.healthcareFacilityTypes;
    }

    get healthcareFacilitiesCombobox(): Array<{ value: string; label: string }> {
        return this.toCombobox(this.healthcareFacilityTypes);
    }

    get healthcareProfessionalTypesCombobox(): Array<{ value: string; label: string }> {
        return this.toCombobox(this.healthcareProfessionalTypes);
    }

    healthcareProfessionalTypeLabel(healthcareProfessionalTypeID: number): string {
        return this.healthcareProfessionalTypes.find((type) => type.id === healthcareProfessionalTypeID)?.name ?? '';
    }

    get titlesCombobox(): Array<{ value: string; label: string }> {
        return this.toCombobox(this.titles);
    }

    private toCombobox(items: Array<{ id: number; name: string }> = []): Array<{ value: string; label: string }> {
        return items.map(({ id, name }) => ({ value: id.toString(), label: name }));
    }
}

export interface IHealthcareProfessionalPayload {
    username: string;
    password: string;
    email: string;
    firstName: string;
    lastName: string;
    preferredLanguage: string;
    titleID: number | null;
    healthcareProfessionalTypeID: number;
    licenseNumber: string;
    phoneNumber?: string;
    allowSMS?: boolean;
    healthcareProfessionalFacilities: IFacilitySelection[];
}

export interface IHealthcareProfessionalForm {
    id: number | null;
    password: string;
    confirmPassword: string;
    email: string;
    firstName: string;
    lastName: string;
    preferredLanguage: string | null;
    titleID: string | null;
    healthcareProfessionalTypeID: string | null;
    licenseNumber: string;
    phoneNumber: string;
    allowSMS: boolean;
    healthcareProfessionalFacilities: IFacilitySelection[];
}

interface idName {
    id: number;
    name: string;
}

export interface IFacilitySelection {
    facilityName?: string;
    healthcareFacilityID: number | string;
    assistant?: string;
    assistantEmail?: string | null;
}
